import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  fetchFcrCoreModules,
  type FcrCoreModulesSnapshot,
} from "../lib/fcrCoreApi";

const POLL_MS = 1000;

export function useFcrCoreModules() {
  const location = useLocation();
  const enabled = location.pathname === "/fcr";
  const [snapshot, setSnapshot] = useState<FcrCoreModulesSnapshot | null>(null);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      const data = await fetchFcrCoreModules();
      setSnapshot(data);
      setError(data.modules.length ? null : data.error ?? null);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    void reload();
    const id = window.setInterval(() => void reload(), POLL_MS);
    return () => window.clearInterval(id);
  }, [enabled, location.key, reload]);

  return {
    snapshot,
    connected: Boolean(snapshot?.modules?.length),
    error: snapshot?.modules?.length ? null : error,
    reload,
  };
}
